module.exports = __webpack_public_path__ + "static/media/add-logo-tablet-en.444c5e07.png";